export enum TransactionType {
  ISSUANCE,
  ROLES,
  CREATE,
  TRANSFER,
  ERROR,
}

export enum ChainID {
  TESTNET = 'T',
  DEVNET = 'D',
  MAINNET = 1,
}
